import React from "react";
import { FaBars } from "react-icons/fa";
import { useGlobalContext } from "./context";
const Home = () => {
  //using a custom hook for grabbing the appcontext
  const data = useGlobalContext();
  console.log(data);
  return (
    <main>
      <button className="sidebar-toggle">
        <FaBars></FaBars>
      </button>
      <button className="btn">Show Modal</button>
    </main>
  );
};

export default Home;
